import React from 'react';
import AuthPageTemplate from './template/auth-page';
import ProfileMenu from './../ui/menu/profile';
import config from './../config';
import theme from './../ui/theme';
import CarrierLocationsListPanel from './../ui/panel/carrier-locations-list';
import { useParams } from 'react-router-dom';

const CarrierLocationsPage = () => {
    const { carrierGroupId } = useParams();
    return (
        <AuthPageTemplate childMenu={ <ProfileMenu /> }>
            {
                /* istanbul ignore next */
                config.features.allowCarrierGroups ? 
                    <div>
                        <CarrierLocationsListPanel 
                            carrierGroupId={carrierGroupId}
                        />
                    </div> : 
                        <p style={{
                            ...theme.getGeneralTextStyle()
                        }}>
                            This feature is currently disabled
                        </p>
            }
        </AuthPageTemplate>
    );
};

export default CarrierLocationsPage;
